export const TOUCH_INTERACTION_DELAY_MS = 150;
